<template>
    <svg height="24px" viewBox="0 0 24 24" width="24px" xmlns="http://www.w3.org/2000/svg">
        <path
            id="coupon-Filled-2"
            class="cls-1"
            d="M21,10.5h.5V9A4.513,4.513,0,0,0,17,4.5h-.5A.5.5,0,0,0,16,5V7a1,1,0,0,1-2,0V5a.5.5,0,0,0-.5-.5H7A4.513,4.513,0,0,0,2.5,9v1.5H3a1.5,1.5,0,0,1,0,3H2.5V15A4.513,4.513,0,0,0,7,19.5h6.5A.5.5,0,0,0,14,19V17a1,1,0,0,1,2,0v2a.5.5,0,0,0,.5.5H17A4.513,4.513,0,0,0,21.5,15V13.5H21a1.5,1.5,0,0,1,0-3Zm-5,3a1,1,0,0,1-2,0v-3a1,1,0,0,1,2,0Z"
            data-name="coupon-Filled"
        />
    </svg>
</template>

<script>
export default {
    name: "Coupon",
};
</script>

<style scoped></style>
